import React, { FC } from "react";
import { DialogTitle, IconButton, makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { color, px } from "Configs/theme";

interface Props {
	title: string;
	isCloseAutoFocusEnabled?: boolean;
	close?: () => void;
}

const ModalTitle: FC<Props> = (props) => {
	const classes = useStyles();

	return (
		<DialogTitle disableTypography className={classes.dialogTitle}>
			{props.close && (
				<IconButton
					autoFocus={props.isCloseAutoFocusEnabled}
					className={classes.backButton}
					onClick={props.close}
				>
					<CloseIcon htmlColor={color.text} />
				</IconButton>
			)}
			<h2 className={classes.headline}>{props.title}</h2>
			{props.children}
		</DialogTitle>
	);
};

export default ModalTitle;

const useStyles = makeStyles({
	dialogTitle: {
		display: "flex",
		alignItems: "center",
	},
	backButton: {
		transform: `translate3d(-8px, 0, 0)`,
	},
	headline: {
		display: "flex",
		alignItems: "center",
		flex: 1,
		height: px.xxxl,
		margin: 0,
		marginRight: px.l,
		textTransform: "uppercase",
		fontWeight: 800,
		letterSpacing: 0,
		fontSize: "16px",
	},
});
